import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { SmartModal } from "soft_digi";
import { useSiteContext } from "../contexts/SiteProvider";
import CertificateVerify from "../pages/sessions/CertificateVerify";
import AdminRoutes from "./AdminRoutes";
import HomeRoutes from "./HomeRoutes";
import LoginRoutes from "./LoginRoutes";

import ExamRoutes from "./ExamRoutes";

const SiteRoute = () => {
  const { isModalOpen, modalOptions, closeModal } = useSiteContext();

  return (
    <>
      <Router>
        <Routes>
          {LoginRoutes()}
          {HomeRoutes()}
          {AdminRoutes()}
          {ExamRoutes()}
          <Route
            path="/cert_verify/:encryptedId"
            element={<CertificateVerify />}
          />
        </Routes>
        {isModalOpen && (
          <SmartModal
            active={isModalOpen}
            {...modalOptions}
            closeFunction={closeModal}
          />
        )}
      </Router>
    </>
  );
};

export default SiteRoute;
